(function () {
  'use strict';

  var drawer = document.getElementById('cdrawer');
  var overlay = document.getElementById('cdrawer-overlay');
  var body = document.getElementById('cdrawer-body');
  if (!drawer || !overlay || !body) return;

  var moneyFormat = window.rayorMoneyFormat || (window.Shopify && window.Shopify.money_format) || '{{amount}} LE';

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(cents) || cents == null) return '0';
    cents = (cents / 100).toFixed(precision);
    var parts = cents.split('.');
    var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var decPart = parts[1] ? decimal + parts[1] : '';
    return intPart + decPart;
  }

  function formatMoney(cents) {
    // Accept decimal strings (from recommendations API) by converting to cents
    if (typeof cents === 'string' && cents.indexOf('.') !== -1) {
      cents = Math.round(parseFloat(cents) * 100);
    } else {
      cents = Number(cents);
    }

    var placeholder = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = placeholder ? placeholder[1] : 'amount';
    var value;

    switch (token) {
      case 'amount':
        value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function openDrawer() {
    overlay.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cdrawer-open');
    loadRecommendations();
  }

  function closeDrawer() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cdrawer-open');
    setTimeout(function () { overlay.hidden = true; }, 420);
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-drawer-toggle]');
    if (toggle) {
      e.preventDefault();
      openDrawer();
      return;
    }
    var close = e.target.closest('[data-cart-drawer-close]');
    if (close) {
      if (close.tagName !== 'A' || !close.getAttribute('href')) e.preventDefault();
      closeDrawer();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  function updateHeaderBadge(count) {
    var badges = document.querySelectorAll('.rayor-header__badge, .cdrawer__count');
    var cartIcons = document.querySelectorAll('.rayor-header__cart, .mnav__icon-link[aria-label="Cart"]');
    cartIcons.forEach(function (icon) {
      var existing = icon.querySelector('.rayor-header__badge');
      if (count > 0) {
        if (existing) {
          existing.textContent = count;
        } else if (icon.classList.contains('rayor-header__cart')) {
          var span = document.createElement('span');
          span.className = 'rayor-header__badge';
          span.textContent = count;
          icon.appendChild(span);
        }
      } else if (existing) {
        existing.remove();
      }
    });
    var countEl = document.getElementById('cdrawer-count');
    if (countEl) countEl.textContent = count;
  }

  function fetchSection() {
    return fetch('/?section_id=cart-drawer-fragment', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .catch(function () { return null; });
  }

  function renderCart(cart) {
    updateHeaderBadge(cart.item_count);
    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cdrawer__empty">' +
          '<div class="cdrawer__empty-icon"><svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></div>' +
          '<p class="cdrawer__empty-title">Your cart is empty</p>' +
          '<a href="/collections/all" class="cdrawer__empty-btn" data-cart-drawer-close>Start shopping</a>' +
        '</div>';
      return;
    }

    var itemsHtml = cart.items.map(function (item, i) {
      var img = item.image ? '<img src="' + item.image.replace(/_(\w+)\./, '_200x.') + '" loading="lazy" alt="' + escapeHtml(item.product_title) + '">' : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ?
        '<span class="cdrawer__item-variant">' + escapeHtml(item.variant_title) + '</span>' : '';
      return '<li class="cdrawer__item" data-key="' + item.key + '" data-line="' + (i + 1) + '">' +
        '<a href="' + item.url + '" class="cdrawer__item-img">' + img + '</a>' +
        '<div class="cdrawer__item-main">' +
          '<a href="' + item.url + '" class="cdrawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
          variant +
          '<div class="cdrawer__item-row">' +
            '<div class="cdrawer__qty">' +
              '<button type="button" class="cdrawer__qty-btn" data-cart-qty="minus" data-key="' + item.key + '" aria-label="Decrease">−</button>' +
              '<span class="cdrawer__qty-val">' + item.quantity + '</span>' +
              '<button type="button" class="cdrawer__qty-btn" data-cart-qty="plus" data-key="' + item.key + '" aria-label="Increase">+</button>' +
            '</div>' +
            '<span class="cdrawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cdrawer__item-remove" data-cart-remove data-key="' + item.key + '" aria-label="Remove">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</li>';
    }).join('');

    var lastProductId = cart.items[cart.items.length - 1].product_id;

    body.innerHTML =
      '<ul class="cdrawer__items">' + itemsHtml + '</ul>' +
      '<section class="cdrawer__recs" id="cdrawer-recs" data-last-product="' + lastProductId + '">' +
        '<h3 class="cdrawer__recs-title">You may also like</h3>' +
        '<div class="cdrawer__recs-track" id="cdrawer-recs-track"><div class="cdrawer__recs-loading">Loading…</div></div>' +
      '</section>' +
      '<footer class="cdrawer__foot">' +
        '<div class="cdrawer__subtotal"><span>Subtotal</span><span class="cdrawer__subtotal-val">' + formatMoney(cart.total_price) + '</span></div>' +
        '<p class="cdrawer__ship">Shipping & taxes calculated at checkout</p>' +
        '<form action="/cart" method="post" novalidate>' +
          '<button type="submit" name="checkout" class="cdrawer__checkout">Checkout <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg></button>' +
        '</form>' +
        '<a href="/cart" class="cdrawer__view-cart">View full cart</a>' +
      '</footer>';

    loadRecommendations();
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function loadRecommendations() {
    var recs = document.getElementById('cdrawer-recs');
    var track = document.getElementById('cdrawer-recs-track');
    if (!recs || !track) return;
    var pid = recs.getAttribute('data-last-product');
    if (!pid || recs.getAttribute('data-loaded') === '1') return;
    recs.setAttribute('data-loaded', '1');
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) { recs.style.display = 'none'; return; }
        track.innerHTML = products.map(function (p) {
          var img = (p.featured_image || (p.images && p.images[0])) || '';
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          var price = p.price_min != null ? p.price_min : p.price;
          var firstVariantId = p.variants && p.variants[0] && p.variants[0].id;
          var addBtn = firstVariantId ?
            '<button type="button" class="cdrawer__rec-add" data-cart-add="' + firstVariantId + '" aria-label="Add to cart"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' : '';
          return '<a href="' + p.url + '" class="cdrawer__rec">' +
            '<div class="cdrawer__rec-img">' + (img ? '<img src="' + img + '" loading="lazy" alt="' + escapeHtml(p.title) + '">' : '') + '</div>' +
            '<p class="cdrawer__rec-title">' + escapeHtml(p.title) + '</p>' +
            '<span class="cdrawer__rec-price">' + formatMoney(price) + '</span>' +
            addBtn +
          '</a>';
        }).join('');
      })
      .catch(function () { recs.style.display = 'none'; });
  }

  body.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var key = qtyBtn.getAttribute('data-key');
      var item = body.querySelector('.cdrawer__item[data-key="' + key + '"]');
      var valEl = item && item.querySelector('.cdrawer__qty-val');
      if (!valEl) return;
      var current = parseInt(valEl.textContent, 10) || 1;
      var next = qtyBtn.getAttribute('data-cart-qty') === 'plus' ? current + 1 : Math.max(0, current - 1);
      updateLine(key, next);
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      var k = rm.getAttribute('data-key');
      var it = body.querySelector('.cdrawer__item[data-key="' + k + '"]');
      if (it) it.classList.add('is-removing');
      updateLine(k, 0);
      return;
    }
    var addRec = e.target.closest('[data-cart-add]');
    if (addRec) {
      e.preventDefault();
      var vid = addRec.getAttribute('data-cart-add');
      addToCart(vid, 1).then(function () { refreshCart(); });
      return;
    }
  });

  function updateLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); });
  }

  function addToCart(variantId, quantity, properties) {
    var payload = { id: variantId, quantity: quantity || 1 };
    if (properties) payload.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  // Intercept all product forms (action contains /cart/add)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || '');
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var btnHtml = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('data-adding', '1'); }

    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer(); })
      .catch(function (err) {
        var msg = (err && err.description) || (err && err.message) || 'Could not add to cart';
        alert(msg);
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('data-adding'); btn.innerHTML = btnHtml; }
      });
  }, true);

  // Initial recs load if drawer has server-rendered items
  if (body.querySelector('#cdrawer-recs')) loadRecommendations();
})();
